const VERSION = "22.0.0";
export {
  VERSION
};
